<template>
  <div v-if="categoriesLoaded">
    <div v-if="hasCategories" class="side-nav-categories">
      <h3 class="mb-4 text-sm font-semibold text-primary-900">{{ currentCategoryName }}</h3>

      <div class="px-4 border-l border-solid border-accent-500">
        <div
          v-for="(category, index) in children"
          :key="category.slug"
          :class="[{ hidden: index >= previewLimit && !showAllCategories }]"
          class="my-3 text-xs font-light cursor-pointer child-category last:my-0"
        >
          <CLink
            :to="linkToPlp(category.slug)"
            variant="dark"
            size="small"
            :bold="false"
            :underline="false"
            :is-disabled="isDisabled"
          >
            {{ category.name }}
          </CLink>
        </div>
      </div>

      <div
        v-show="isButtonVisible"
        class="flex items-center px-4 mx-5 mt-4 text-xs font-semibold cursor-pointer"
        @click="displayAllCategories()"
      >
        <div>Visa alla {{ children.length }}</div>
        <CIcon class="pl-2" name="expand_more" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
type BreadcrumbChildren = {
  name: string;
  slug: string;
};

type Props = {
  breadcrumb?: {
    children: BreadcrumbChildren[];
    name?: string;
    slug?: string;
  };
  isDisabled?: boolean;
};

const props = withDefaults(defineProps<Props>(), {
  breadcrumb: () => ({
    children: [],
    name: undefined,
    slug: undefined,
  }),
  isDisabled: false,
});

const route = useRoute();

const showAllCategories = ref(false);
const previewLimit = ref(8);

const currentCategoryName = computed<string>(() => props.breadcrumb?.name || '');
const children = computed(() => props.breadcrumb?.children || []);
const categoriesLoaded = computed(() => !!props.breadcrumb);
const isButtonVisible = computed(() => !showAllCategories.value && children.value.length > previewLimit.value);
const hasCategories = computed(() => children.value);

const displayAllCategories = () => {
  showAllCategories.value = true;
};

watch(
  () => route,
  () => {
    showAllCategories.value = false;
  },
);
</script>

<script lang="ts">
export default defineComponent({
  name: 'SideNavCategories',
});
</script>
